import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { TextKeywordDetailPage } from '@/features/text-keywords';
import { formatDocumentTitle } from '@/lib/document-title';

/** One text keyword — `/marketing/text-keywords/{id}` (its own screen, not nested in the list). */
export const Route = createFileRoute('/_auth/$orgId/marketing/text-keywords_/$keywordId')({
  component: TextKeywordRoute,
});

function TextKeywordRoute() {
  const { orgId, keywordId } = Route.useParams();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Text Keyword', 'Marketing')}</title>
      </Helmet>
      <TextKeywordDetailPage routeOrgId={orgId} keywordId={keywordId} />
    </>
  );
}
